export const agentJobsAutomationsHeader = "oqE$ub";
export const agentJobsWorkflowsHeader = "m3qxie";
export default {agentJobsAutomationsHeader,agentJobsWorkflowsHeader};